
export const isVideo = (src) => /\.(mp4|mov)(\?.*)?$/i.exec(src);
export const isImage = (src) => /\.(jpe?g|gif|png)(\?.*)?$/i.exec(src);